import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function ContentDetail() {
  const { id } = useParams();
  const [c, setC] = useState(null);

  useEffect(() => {
    api.get(`/library/${id}`).then((r) => setC(r.data));
  }, [id]);

  if (!c) return <div className="min-h-screen bg-[#F9F6F0]"><Header /><div className="p-20 text-center text-[#5C6359]">Loading…</div></div>;

  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <Header />
      <article className="max-w-3xl mx-auto px-6 sm:px-12 pt-16 pb-24">
        <Link to="/library" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#5C6359] hover:text-[#C05C42] mb-10" data-testid="back-to-library">
          <ArrowLeft className="w-4 h-4" /> Back to library
        </Link>
        <p className="label-eyebrow mb-4 text-[#C05C42]">{c.category} · {c.tradition}</p>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#2D322B] leading-tight">{c.title}</h1>
        <p className="mt-4 text-[#5C6359] text-sm uppercase tracking-widest">{c.reading_time} read</p>
        <div className="mt-10 rounded-3xl overflow-hidden border border-[#D1C7B8]">
          <img src={c.image} alt={c.title} className="w-full h-[420px] object-cover" />
        </div>
        <p className="mt-10 text-lg text-[#5C6359] leading-relaxed font-serif italic">{c.excerpt}</p>
        <div className="mt-8 text-[#2D322B] text-base leading-relaxed whitespace-pre-line">
          {c.body}
        </div>
      </article>
      <Footer />
    </div>
  );
}
